import type { DataSourceType } from '../types';

export function isCompanySource(dataSource: DataSourceType | string): boolean {
  return dataSource === 'company' || dataSource === 'accounts';
}

export function entityNoun(dataSource: DataSourceType | string, count = 2): string {
  if (isCompanySource(dataSource)) {
    return count === 1 ? 'company' : 'companies';
  }
  return count === 1 ? 'contact' : 'contacts';
}

export function entityNounCap(dataSource: DataSourceType | string, count = 2): string {
  const noun = entityNoun(dataSource, count);
  return noun.charAt(0).toUpperCase() + noun.slice(1);
}
